import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 24,
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m15.815 11.07c-.26.227-.54.425-.839.594a5.518 5.518 0 0 1 3.095 4.954v5.47h-11.131v-5.47c0-2.21 1.308-4.112 3.195-5.004a5.42 5.42 0 0 1 -.83-.614c-1.966 1.11-3.305 3.21-3.305 5.609v6.391h13v-6.391c0-2.349-1.278-4.41-3.185-5.54zm-2.815-.07c-2.206 0-4-2.24-4-5s1.794-5 4-5 4 2.24 4 5c-.01 2.75-1.803 5-4 5zm0-9.023c-1.707 0-3.108 1.804-3.108 4.012 0 2.22 1.391 4.013 3.108 4.013 1.707 0 3.108-1.805 3.108-4.013-.01-2.208-1.4-4.012-3.108-4.012z" })
});
export default SvgUser;
